import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutNmfcCodeLookup extends Layout {
    sourceCodeNmfcClass: DataSource;
    tableNmfcCode: Table;
}
